import type {
  FormLabelProps as ChakraFormLabelProps
} from '@chakra-ui/react'
import {
  Box,
  FormLabel as ChakraFormLabel,
  Grid,
  Spinner,
  Stack,
  Text,
} from '@chakra-ui/react'
import React from 'react'
import { Hint, type HintProps } from './Hint'

export interface FormLabelProps extends ChakraFormLabelProps {
  children?: React.ReactNode
  hint?: React.ReactNode
  hintType?: HintProps['type']
  icon?: React.ReactNode
  optional?: boolean | undefined
  isLoading?: boolean | undefined
}

export const FormLabel = ({
  children,
  hint,
  hintType,
  icon,
  optional,
  isLoading,
  ...rest
}: FormLabelProps) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridAutoFlow: 'column',
        gap: 2,
        alignItems: 'center',
        w: '100%',
      }}
    >
      <Box sx={{ display: 'flex', columnGap: 4, justifyContent: 'space-between' }}>
        <Box
          sx={{
            display: 'flex',
            columnGap: 2,
            alignContent: 'center',
            alignItems: 'center',
            justifyContent: 'center',
            justifyItems: 'center',
          }}
        >
          {icon && <Grid sx={{ h: '2.25rem', alignContent: 'end', mr: 3 }}>{icon}</Grid>}

          <ChakraFormLabel {...rest}>{children}</ChakraFormLabel>

          {hint && <Hint
            type={hintType}
            maxW={500}
            hasArrow
            placement='top'
          >{hint}</Hint>}
        </Box>

        {optional ||
          (isLoading && (
            <Stack direction="row" sx={{ ml: 'auto' }}>
              {optional && (
                <Text variant="textMuted" sx={{ fontSize: 'sm' }}>
                  Nepovinné
                </Text>
              )}

              {isLoading && <Spinner />}
            </Stack>
          ))}
      </Box>
    </Box>
  )
}
